export enum AuthFlowType {
    OTP = 'OTP',
    PASSWORD = 'PASSWORD',
}
